import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
const cn = {
  LoginPage: {
    text1: '登录您的账户',
    text2: '邮箱/手机号',
    text3: '输入图形码',
    text4: '密码',
    text5: '忘记密码？',
    text6: '登录',
    text7: '我已同意并阅读',
    text8: '和',
    text9: '《用户协议》',
    text10: '《隐私政策》',
    text11: '或者',
    text12: '注册账户',
    text13: '提示',
    text14: '阅读并同意',
    text15: '取 消',
    text16: '同 意',
    text17: '注册成功', 
    text18: '登录成功', 
    text19: '请输入有效的邮箱/手机号', 
    text20: '账号密码错误', 
    text21: '请输入密码', 
    text22: '密码长度不能少于8位', 
    text23: '密码必须包含字母和数字', 
    text24: '密码不一致', 
  },
  RegisterPage: {
    text1: '注册',
    text2: '邮箱/手机号',
    text3: '发送验证码',
    text4: '密码',
    text5: '再次确认密码',
    text6: '至少8位数，字母和数字组成',
    error1:'请输入有效的邮箱/手机号',
    error2:'请输入验证码',
    error3:'账号密码错误',
    text7: '验证码'
  },
  ResetPassword: {
    text1: '重置密码',
    text2: '再次确认密码',
    text3: '至少8位数，字母和数字组成',
    text4: '确认',
    text5: '重置成功',
  },
  ForgotPassword: {
    text1: '找回密码',
    text2: '邮箱/手机号',
    text3: '发送验证码',
    text4: '下一步',
    text5: '后重新发送',
    text6: '请输入有效的验证码',
  },
  HomePage: {
    headerText1: '首页',
    headerText2: '文本翻译',
    headerText3: '语音翻译',
    headerText4: 'AI智能体',
    headerText5: '资源',
    buttonText1: '登录',
    buttonText2: '免费试用',
    langText1: '中文（繁体）',
    langText2: '中文（简体）',
    langText3: 'English（英语）',
    resources1: 'API文档',
    resources2: '探索我们的API文档',
    resources3: '常见问题',
    resources4: '问题和解决方案',
    resources5: '联系我们',
    resources6: '详细咨询详情',
    scheme1: '请选择合适的方案',
    scheme2: '超低价格·多语言支持·方案定制，联系客服',
    scheme3: '文本翻译',
    scheme4: '语音翻译',
    scheme5: '文档翻译',
    scheme6: '基础版',
    scheme7: '/百万字符',
    scheme8: '并发(qps)',
    scheme9: '5～1000(支持扩展)',
    scheme10: '百度翻译-企业版本',
    scheme11: '有道翻译',
    scheme12: '火山翻译',
    scheme13: 'yandex',
    scheme14: '了解详情',
    scheme15: '高级版',
    scheme16: 'DeepL- API PRO',
    scheme17: '谷歌翻译- V2/V3',
    scheme18: '微软翻译',
    scheme19: '标准版',
    scheme20: 'ChatGPT翻译',
    scheme21: '语音转文字识别',
    scheme22: '/小时',
    scheme23: '100(支持扩展)',
    scheme24: '指定语言语音翻译',
    scheme25: '自动识别语言语音翻译',
    scheme26: 'DeepL翻译',
    num1: 25,
    num2: 60,
    num3: 50,
    num4: 3.6,
    num5: 9.1,
    num6: 10.2,
    num7: 90,
    num8: 5,
    fanyi1: '连接顶尖翻译引擎，匹配您的场景需求',
    fanyi2: '无论是商务文档、跨境电商还是技术本地化，我们都能为您精准调度最优翻译资源，实现高效、安全、低成本的全球化沟通。',
    fanyi3: '文本翻译',
    fanyi4: '语音翻译',
    fanyi5: '语音识别',
    fanyi6: 'AI实时翻译，提供多元化方案',
    fanyi7: '140+语言方言 · 400+高品质音色 · 随心选择(接口免费试用)',
    intelligent1: 'AI智能体：您的数字世界超级助手',
    intelligent2: '支持语音、文字的多维沟通，能提供实时对话机器人、写作助手以及学习助手等功能，可以回答科学、技术、历史、文化、娱乐等各种领域的问题',
    intelligent3: '智能助手',
    intelligent4: '语音对话',
    support1: '选择我们的优势',
    support2: '认证技术支持',
    support3: '我们的资深AI语音技术团队提供微软TTS/STT全栈解决方案，让企业级语音交互高效落地，释放智能语音的商业价值！',
    support4: '综合代理服务商',
    support5: '聚合多家头部技术服务商，提供最优技术组合方案，多元化的资源整合能力和专业服务，能为企业客户创造显著价值',
    support6: '优势渠道价格',
    support7: '我们是主流翻译引擎综合代理服务商，汇集众多企业客户，我们可提供优势渠道价格',
    footer1: '预约您的专属解决方案顾问，获取定制化报价方案',
    footer2: '请输入您的姓名',
    footer3: '请输入您的电话',
    footer4: '预约',
    footer5: '预约成功，请留意您的来电信息',
    footer6: '关于我们：',
    footer7: 'XRION TECHNOLOGY LIMITED',
    footer8: '邮箱：admin@xrion.ai',
    footer9: '香港手机号：+852 4640 4336',
    footer10: '翻译',
    footer11: 'AI大模型',
    footer12: '资源',
    footer13: '文本翻译',
    footer14: 'AI智能体',
    footer15: 'API文档',
    footer16: '语音翻译',
    footer17: '常见问题',
    footer18: '港ICP备8384773838282号-1',
    expect: '敬请期待',
    text1:'香港手机号',
    text2:'AI库下载',
    text3:'用户协议',
    text4:'隐私政策',
    text5:'付费协议',
    text6:'返回',
    text7:'原价：' 
  },
  TextTranslation: {
    text1: '控制台',
    text2: '退出登录',
    text3: '自动检测',
    text4: '输入文本，自动翻译...',
    text5: '语言搜索',
    text6: '检测语言',
    text7: '搜索语言',
    text8: '请选择目标语言',
    text9: '请先登录',
  },
  VoicePage: {
    text1: '语音翻译',
    text2: '语音识别',
    text3: '定向翻译',
    text4: '仅显示翻译目标语言',
    text5: '双向翻译',
    text6: '自动识别双语言翻译',
    text7: '录入语言:',
    text8: '识别结果（单次识别最长支持1分钟）',
    text9: '翻译余额不足，请先充值',
    text10: '取 消',
    text11: '去充值',
    text12: '中文(普通话,简体)',
    text13: '英文（美国）',
    text14: '这里显示目标语言翻译结果...',
    text15: '这里显示语音识别结果...'
  },
  ConsolePanel: {
    text1: "翻译密钥",
    text2: "复制",
    text3: "查看API密钥",
    text4: "充值",
    text5: "提示：1.如有使用问题或需发票协助，请联系客服",
    text6: "使用统计图",
    text7: "近7天",
    text8: "近15天",
    text9: "近30天",
    text10: "复制成功",
    text11: "使用详情",
    text12: "操作",
    text13: "翻译引擎",
    text14: "价格（百万字符）",
    text15: "已使用字符数",
    text16: "剩余字符数",
    text17: "查看API公钥",
    text18: "字符",
    text19: "2.汇率每日更新，实际支付金额可能因汇率波动略有调整",
    text20: "货币:",
    text21: "DeepL",
    text22: "谷歌翻译",
    text23: "微软翻译",
    text24: "百度翻译-企业版本",
    text25: "有道翻译",
    text26: "火山翻译",
    text27: "chatGPT翻译",
    text28: "yandex",
    text29:'服务类型',
    text30:'原价（小时）',
    text31:'限时优惠价（小时）',
    text32:'已消耗时长',
    text33:'已消耗费用',
    text34:'剩余金额',
    text35:'语音转文字识别',
    text36:'指定语言语音翻译',
    text37:'自动识别语言语音翻译',
    text38:'原价(百万字符）',
    text39:'优惠价(元/百万字符）',
    text40:'元',
    text41:'美元',
    text42:'费用'

  },
  PayPage: {
    text1: '充值订单',
    text2: '服务信息',
    text3: '用户ID',
    text4: '充值产品',
    text5: '翻译引擎',
    text6: '充值字符数量',
    text7: '百万',
    text8: '价格',
    text9: '/百万字符',
    text10: '合计',
    text11: '支付方式',
    text12: '已阅读并同意',
    text13: '《XRION服务付费协议》',
    text14: '支付',
    text15: '翻译字符数量不足，请先充值',
    text16: '提交订单',
    text17: '确定支付',
    text18: '支付成功',
    text19: '支付失败',
    text20: '微信支付',
    text21: '支付宝',
    text22: '余额',
    text23: '充值金额',
    text24:'元'
  },
  OrderPage:{
    Text1:'支付金额：',
    Text2:'请在倒计时',
    Text3:'分钟',
    Text4:'秒',
    Text5:'前完成支付，否则订单将自动取消',
    Text6:'打开手机支付宝',
    Text7:'打开手机微信',
    Text8:'扫一扫继续支付',
    Text9:'已超时',
    Text10:'订单已超时，请返回控制台重新提交订单',
    Text11:'支付成功',
    Text12:'支付超时',
    Text13:'离开代表您放弃支付该订单,确认离开吗',
    Text14:'您还未支付成功,请勿离开当前界面!',
    Text15:'确定',
    Text16:'取消',
  },
  StripePay: {
    text1:'订单提交成功，支付订单号：',
    text2:'订单信息：',
    text3:'百万字符',
    text4:'支付金额：',
    text5:'语音翻译余额充值'
  },
  PayResult:{
    text1:'返回控制台',
  },
  IntelligentAgent: {
    Text1:'搜索历史记录',
    Text2:'删除',
    Text3:'Hi！我是您的智能助手',
    Text4:'输入您的反馈和建议～',
    Text5:'提交',
    Text6:'输入您的问题...',
    Text7:'删除对话',
    Text8:'删除后，该对话不可恢复。确认删除吗？',
    Text9:'取消',
    Text10:'收起侧边栏',
    Text11:'展开',
  },
  FAQPage: {
    Title:"常见问题",
    Question1:'Q1.XRION是如何服务客户的？',
    Text1:'我们是一个聚合翻译服务商，聚合主流的翻译公司接口，提供更便宜、多样化的翻译服务。',
    Question2:'Q2.当前提供哪些翻译引擎？',
    Text2:'DeepL、谷歌、百度、有道翻译、微软、火山翻译、OpenAI、YanDex。',
    Question3:'Q3.翻译字符是如何计费的？',
    Text3:'按字符数计算您的使用量。计算的字符是源文本中的字符数，即您要翻译的原文。一个字符对应于一个 UTF-8 编码后的代码点，即一个汉字或者英文字母都算一个字符。翻译的字符数与所使用的翻译服务对应的计费倍率相乘后取整得到最终的计费字符数。',
    Question4:'Q4.是否可以开启增值税发票？',
    Text4:'可以。联系客服即可开取增值税发票，如需开票，需提前预约。',
    Question5:'Q5.是否会存储我的翻译请求？',
    Text5:'不存储任何您请求的文本或其翻译结果。只有关于请求的元数据（请求的时间和翻译的字符数）会被保存用于计费和统计的目的。',
    Question6:'Q6.我的翻译源文本和翻译结果是否会有泄漏风险？',
    Text6:'绝不存储您的翻译源文本和翻译结果，然而我们无法保证上游服务的数据储存规则。请在使用不同的服务的时候参考对应服务的隐私条例来规避风险。',
  },
  errorMsg1:'目前识别中,请稍后...',
  ...zhLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default cn;
